/**
 * Licent
 *
 * @author Robuust
 * @author Rutger Bakker <rutger@robuust.digital>
 */

import { Controller } from '@hotwired/stimulus';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

/**
 * GSAP controller.
 */
export default class extends Controller {
  static values = {
    total: {
      type: Number,
      default: 0,
    },
    delay: {
      type: Number,
      default: 0,
    },
    scroll: Boolean,
  };

  /**
   * GSAP context.
   */
  ctx = null;

  /**
   * Connect.
   */
  connect() {
    if (this.hasTotalValue) {
      this.ctx = gsap.context(() => {
        const counter = { value: 0 };

        gsap.to(counter, {
          value: this.totalValue,
          duration: 3,
          ease: 'power3.out',
          roundProps: 'value',
          onUpdate: () => {
            const value = Math.round(counter.value);
            const totalDigits = this.totalValue.toString().length;
            this.element.textContent = value.toString().padStart(totalDigits, '0');
          },
          delay: this.delayValue,
          scrollTrigger: this.scrollValue ? {
            trigger: this.element,
            start: 'top 80%',
            once: true,
          } : null,
        });
      }, this.element);
    }
  }

  /**
   * Disconnect.
   */
  disconnect() {
    if (this.ctx) {
      this.ctx.revert();
    }
  }
}
